module.exports = __webpack_public_path__ + "static/colors-b373f48e44abfa7b933f216f25b8e918.png";